import React, { memo } from 'react';

import { Icon, Space, Typography } from '@sravni/react-design-system';
import { ArrowDown } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';

import { ExtendedNewsOrg } from '../../interfaces/organizations';

import { OrganizationLogo } from './components/OrganizationLogo';
import { OrganizationMenu } from './components/OrganizationMenu';
import styles from './heading-blog.module.scss';

interface IProps {
  organization: ExtendedNewsOrg;
  onFieldClick?: () => void;
}

export const HeadingBlog = memo<IProps>(({ onFieldClick, organization }) => {
  const isMobile = useIsMobile();

  const handleClick = () => {
    if (isMobile) onFieldClick();
  };

  return (
    <div className={styles.wrapper}>
      <Space align={'center'} justify={'space-between'} className={!organization && 'h-mb-12'}>
        <Space align={'center'} size={12}>
          {organization && (
            <OrganizationLogo
              logoSrc={organization.logotype}
              isPartner={organization.isPartner}
              size={isMobile ? 52 : 60}
            />
          )}
          <Space direction="vertical">
            <Typography.Heading
              className={!organization && styles.headingCommon}
              level={isMobile ? 3 : 2}
              as={'h1'}
              onClick={handleClick}
            >
              {organization.name}
              {isMobile && !organization && <Icon icon={<ArrowDown />} className={'h-ml-8'} />}
            </Typography.Heading>
            <Typography.Text className={styles.subtitle} size={14}>
              {organization.fullName}
            </Typography.Text>
          </Space>
        </Space>
      </Space>
      {!organization && (
        <Typography.Text size={14} className={'h-color-D60'}>
          Новости о финансах, инвестициях и других финансовых продуктах партнёров Сравни
        </Typography.Text>
      )}
      {organization && <OrganizationMenu organizationAlias={organization.alias} />}
    </div>
  );
});
